import styled from "styled-components";

export const PageHeader = styled.div`
  margin-bottom: 24px;
  h1 { font-size: 24px; font-weight: 600; color: #014c75; margin: 0 0 8px 0; }
  p { color: #666; margin: 0; font-size: 14px; }
`;

export const ProjectsWrapper = styled.div`
  min-height: 100vh;

  .header-actions {
    display: flex;
    gap: 12px;
    align-items: center;
    margin-bottom: 24px;

    .view-toggle {
      display: flex;
      border: 1px solid #d9d9d9;
      border-radius: 6px;
      overflow: hidden;

      .toggle-btn {
        border: none;
        border-radius: 0;
        padding: 8px 16px;

        &.active {
          background: #01d9a9;
          color: white;
        }
      }
    }
  }

  .metrics-row {
    margin-bottom: 24px;

    .metric-card {
      border-radius: 12px;
      transition: all 0.3s ease;

      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
      }

      .metric-content {
        display: flex;
        align-items: center;
        gap: 16px;

        .metric-icon {
          width: 56px;
          height: 56px;
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .metric-info {
          .metric-value {
            font-size: 28px;
            font-weight: 700;
            color: #014c75;
            margin: 0;
            line-height: 1.2;
          }

          .metric-label {
            font-size: 14px;
            color: #8c8c8c;
            margin: 0;
          }
        }
      }
    }
  }

  .tabs-section {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    margin-bottom: 24px;
    flex-wrap: wrap;

    .tab-button {
      border: none;
      background: transparent;
      padding: 8px 20px;
      border-radius: 8px;
      font-weight: 500;
      cursor: pointer;
      transition: all 0.3s ease;

      &.active {
        background: #01d9a9;
        color: white;
      }

      &:hover:not(.active) {
        background: #f0f0f0;
      }
    }
  }

  .filters-section {
    display: flex;
    gap: 12px;
    margin-bottom: 24px;
    flex-wrap: wrap;
  }

  .projects-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(380px, 1fr));
    gap: 20px;
  }

  .project-card {
    border-radius: 12px;
    overflow: hidden;
    transition: all 0.3s ease;

    &:hover {
      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
    }

    .card-header {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      margin-bottom: 12px;

      .project-id {
        font-size: 12px;
        color: #8c8c8c;
        margin-bottom: 4px;
      }

      .project-title {
        font-size: 18px;
        font-weight: 600;
        color: #014c75;
        margin: 0;
        cursor: pointer;

        &:hover {
          color: #01d9a9;
        }
      }

      .action-icon {
        font-size: 20px;
        cursor: pointer;
        padding: 4px;
        border-radius: 4px;

        &:hover {
          background: #f0f0f0;
        }
      }
    }

    .card-meta {
      display: flex;
      flex-wrap: wrap;
      gap: 8px;
      margin-bottom: 16px;
    }

    .card-description {
      font-size: 14px;
      color: #595959;
      margin-bottom: 16px;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }

    .engagement-link {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 8px 12px;
      background: #f5f5f5;
      border-radius: 6px;
      margin-bottom: 12px;
      font-size: 13px;
      color: #595959;
      cursor: pointer;

      &:hover {
        background: #e8e8e8;
        color: #014c75;
      }
    }

    .health-indicators {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 8px 12px;
      background: #fafafa;
      border-radius: 6px;
      margin-bottom: 8px;
      
      .health-separator {
        color: #d9d9d9;
        font-weight: 300;
      }

      .health-item {
        display: flex;
        align-items: center;
        gap: 4px;

        .health-label {
          font-size: 12px;
          color: #8c8c8c;
        }
        
        .health-jobs-value {
          font-size: 12px;
          font-weight: 600;
          color: #014c75;
        }

        .health-value {
          font-size: 12px;
          font-weight: 600;

          &.good {
            color: #52c41a;
          }

          &.warning {
            color: #faad14;
          }

          &.critical {
            color: #ff4d4f;
          }
        }
      }
    }

    .card-footer {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-top: 12px;
      border-top: 1px solid #f0f0f0;

      .budget-info {
        font-size: 13px;
        color: #595959;

        .budget-value {
          font-weight: 600;
          color: #014c75;
        }
      }

      .jobs-info {
        font-size: 12px;
        color: #8c8c8c;
      }
    }
  }

  .empty-card {
    grid-column: 1 / -1;
  }
`;

export const ProjectTableWrapper = styled.div`
  .ant-table {
    border-radius: 8px;
    overflow: hidden;
  }

  .project-title-link {
    color: #014c75;
    font-weight: 500;
    cursor: pointer;

    &:hover {
      color: #01d9a9;
    }
  }

  .health-badge {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 2px 8px;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 500;

    &.good {
      background: #f6ffed;
      color: #52c41a;
    }

    &.warning {
      background: #fffbe6;
      color: #faad14;
    }

    &.critical {
      background: #fff2f0;
      color: #ff4d4f;
    }
  }
`;

export const CreateProjectWrapper = styled.div`
  min-height: 100vh;
  background: linear-gradient(135deg, #f8fafc 0%, #e8f4f8 50%, #dff0f7 100%);
  padding: 0;
  font-family: 'Inter', 'Poppins', -apple-system, BlinkMacSystemFont, sans-serif;

  .survey-container {
    max-width: 800px;
    margin: 0 auto;
    padding: 40px 24px;
  }

  .welcome-screen {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 80vh;
    text-align: center;
    padding: 40px 24px;

    .welcome-icon {
      width: 80px;
      height: 80px;
      background: linear-gradient(135deg, #01d9a9 0%, #014c75 100%);
      border-radius: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 32px;
      box-shadow: 0 12px 40px rgba(1, 217, 169, 0.3);

      svg {
        font-size: 36px;
        color: white;
      }
    }

    .welcome-title {
      font-family: 'Poppins', sans-serif;
      font-size: 36px;
      font-weight: 700;
      color: #014c75;
      margin-bottom: 16px;
      line-height: 1.2;
    }

    .welcome-subtitle {
      font-size: 18px;
      color: #64748b;
      max-width: 500px;
      line-height: 1.6;
      margin-bottom: 40px;
    }

    .start-button {
      height: 56px;
      padding: 0 48px;
      font-size: 18px;
      font-weight: 600;
      border-radius: 12px;
      background: linear-gradient(135deg, #01d9a9 0%, #00b894 100%);
      border: none;
      box-shadow: 0 8px 24px rgba(1, 217, 169, 0.4);
      transition: all 0.3s ease;

      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 12px 32px rgba(1, 217, 169, 0.5);
        background: linear-gradient(135deg, #00e8b5 0%, #01d9a9 100%);
      }
    }

    .privacy-note {
      margin-top: 32px;
      padding: 16px 24px;
      background: rgba(255, 255, 255, 0.8);
      border-radius: 12px;
      font-size: 13px;
      color: #64748b;
      max-width: 500px;
      border: 1px solid rgba(1, 76, 117, 0.1);
    }

    .creation-options {
      display: flex;
      gap: 24px;
      margin: 32px 0;
      max-width: 720px;
      
      @media (max-width: 768px) {
        flex-direction: column;
      }

      .option-card {
        flex: 1;
        background: white;
        border-radius: 16px;
        padding: 32px 24px;
        cursor: pointer;
        border: 2px solid #e8e8e8;
        transition: all 0.3s ease;
        position: relative;
        text-align: left;

        &:hover {
          border-color: #01d9a9;
          transform: translateY(-4px);
          box-shadow: 0 12px 32px rgba(1, 217, 169, 0.15);
        }

        .option-icon {
          width: 56px;
          height: 56px;
          border-radius: 14px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 20px;
          font-size: 28px;
        }

        .option-title {
          font-size: 18px;
          font-weight: 700;
          color: #014c75;
          margin-bottom: 12px;
        }

        .option-description {
          font-size: 14px;
          color: #64748b;
          line-height: 1.6;
          margin-bottom: 16px;
        }

        .option-features {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;

          span {
            font-size: 12px;
            padding: 4px 10px;
            background: #f0f7ff;
            color: #014c75;
            border-radius: 20px;
            font-weight: 500;
          }
        }

        .option-badge {
          position: absolute;
          top: 16px;
          right: 16px;
          font-size: 11px;
          padding: 4px 10px;
          border-radius: 20px;
          font-weight: 600;
          
          &.recommended {
            background: linear-gradient(135deg, #01d9a9 0%, #00b894 100%);
            color: white;
          }
        }

        &.ai-option {
          .option-icon {
            background: linear-gradient(135deg, #01d9a9 0%, #00b894 100%);
            color: white;
          }
        }

        &.manual-option {
          .option-icon {
            background: linear-gradient(135deg, #e8f4f8 0%, #d1ecf4 100%);
            color: #014c75;
          }
        }
      }
    }
  }

  .form-wrapper {
    .back-button {
      display: inline-flex;
      align-items: center;
      gap: 8px;
      color: #64748b;
      font-size: 14px;
      cursor: pointer;
      margin-bottom: 24px;
      padding: 8px 0;
      transition: color 0.2s;

      &:hover {
        color: #014c75;
      }
    }

    .progress-section {
      margin-bottom: 40px;

      .step-indicator {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        margin-bottom: 16px;

        .step-dot {
          width: 12px;
          height: 12px;
          border-radius: 50%;
          background: #e2e8f0;
          transition: all 0.3s ease;

          &.active {
            background: #01d9a9;
            box-shadow: 0 0 0 4px rgba(1, 217, 169, 0.2);
          }

          &.completed {
            background: #014c75;
          }
        }

        .step-line {
          width: 40px;
          height: 3px;
          background: #e2e8f0;
          border-radius: 2px;

          &.completed {
            background: #014c75;
          }
        }
      }

      .step-info {
        text-align: center;

        .step-label {
          font-size: 14px;
          color: #94a3b8;
          margin-bottom: 4px;
        }

        .step-title {
          font-family: 'Poppins', sans-serif;
          font-size: 28px;
          font-weight: 700;
          color: #014c75;
          margin: 0;
        }

        .step-description {
          font-size: 16px;
          color: #64748b;
          margin-top: 8px;
        }
      }
    }

    .form-card {
      background: white;
      border-radius: 24px;
      padding: 40px;
      box-shadow: 0 4px 24px rgba(0, 0, 0, 0.06);
      border: 1px solid rgba(255, 255, 255, 0.8);

      .ant-form-item {
        margin-bottom: 28px;

        .ant-form-item-label > label {
          font-size: 15px;
          font-weight: 600;
          color: #334155;
          height: auto;
          margin-bottom: 8px;
        }

        .ant-input,
        .ant-select-selector,
        .ant-picker,
        .ant-input-number {
          border-radius: 12px !important;
          border: 2px solid #e2e8f0 !important;
          padding: 12px 16px !important;
          font-size: 15px !important;
          transition: all 0.2s ease !important;
          min-height: 48px;

          &:hover {
            border-color: #01d9a9 !important;
          }

          &:focus,
          &.ant-select-focused {
            border-color: #01d9a9 !important;
            box-shadow: 0 0 0 3px rgba(1, 217, 169, 0.1) !important;
          }
        }

        .ant-select-selector {
          padding: 6px 12px !important;
        }

        .ant-input-textarea textarea {
          padding: 16px !important;
          min-height: 120px;
        }

        .ant-picker-range {
          width: 100%;
        }
      }

      .form-section-title {
        font-family: 'Poppins', sans-serif;
        font-size: 18px;
        font-weight: 600;
        color: #014c75;
        margin-bottom: 24px;
        padding-bottom: 12px;
        border-bottom: 2px solid #f1f5f9;
      }

      .slider-wrapper {
        padding: 16px 24px;
        background: #f8fafc;
        border-radius: 16px;
        margin-top: 8px;

        .slider-labels {
          display: flex;
          justify-content: space-between;
          margin-bottom: 8px;
          font-size: 13px;
          color: #64748b;
        }

        .slider-value {
          text-align: center;
          font-size: 24px;
          font-weight: 700;
          color: #014c75;
          margin-bottom: 12px;
        }

        .ant-slider {
          margin: 0;

          .ant-slider-track {
            background: linear-gradient(90deg, #01d9a9, #014c75);
            height: 8px;
          }

          .ant-slider-rail {
            background: #e2e8f0;
            height: 8px;
          }

          .ant-slider-handle {
            width: 24px !important;
            height: 24px !important;
            border: 3px solid #014c75 !important;
            background: white !important;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15) !important;
            margin-top: -8px !important;
            border-radius: 50% !important;
            inset-block-start: 0 !important;

            &:hover,
            &:focus {
              border-color: #01d9a9 !important;
              box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15) !important;
              outline: none !important;
            }

            &::before {
              display: none !important;
            }

            &::after {
              display: none !important;
            }
          }

          .ant-slider-handle-dragging {
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15) !important;
            border-color: #01d9a9 !important;
          }
        }
      }

      .tech-select-wrapper {
        .ant-select-selection-item {
          background: linear-gradient(135deg, #e8f7f5 0%, #d1f4ed 100%);
          border: 1px solid #01d9a9;
          border-radius: 8px;
          padding: 4px 12px;
          font-weight: 500;
          color: #014c75;
        }
      }

      .custom-tech-input {
        display: flex;
        gap: 12px;
        margin-top: 16px;

        .ant-input {
          flex: 1;
        }

        .add-tech-btn {
          height: 48px;
          padding: 0 24px;
          border-radius: 12px;
          background: #f1f5f9;
          border: 2px dashed #cbd5e1;
          color: #64748b;
          font-weight: 500;

          &:hover {
            background: #e8f7f5;
            border-color: #01d9a9;
            color: #01d9a9;
          }
        }
      }

      .option-cards {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
        gap: 12px;
        margin-top: 8px;

        .option-card {
          padding: 16px;
          border: 2px solid #e2e8f0;
          border-radius: 12px;
          text-align: center;
          cursor: pointer;
          transition: all 0.2s ease;
          background: white;

          &:hover {
            border-color: #01d9a9;
            background: #f8fffd;
          }

          &.selected {
            border-color: #01d9a9;
            background: linear-gradient(135deg, #e8f7f5 0%, #d1f4ed 100%);

            .option-label {
              color: #014c75;
            }
          }

          .option-icon {
            font-size: 28px;
            margin-bottom: 8px;
          }

          .option-label {
            font-size: 14px;
            font-weight: 600;
            color: #64748b;
          }
        }
      }
    }

    .form-actions {
      display: flex;
      justify-content: space-between;
      margin-top: 32px;
      padding-top: 24px;

      .nav-btn {
        height: 52px;
        padding: 0 32px;
        border-radius: 12px;
        font-size: 16px;
        font-weight: 600;
        transition: all 0.2s ease;

        &.prev-btn {
          background: white;
          border: 2px solid #e2e8f0;
          color: #64748b;

          &:hover {
            border-color: #014c75;
            color: #014c75;
          }
        }

        &.next-btn {
          background: linear-gradient(135deg, #01d9a9 0%, #00b894 100%);
          border: none;
          color: white;
          box-shadow: 0 4px 16px rgba(1, 217, 169, 0.3);

          &:hover {
            transform: translateY(-1px);
            box-shadow: 0 6px 20px rgba(1, 217, 169, 0.4);
          }

          &:disabled {
            background: #e2e8f0;
            box-shadow: none;
          }
        }

        &.submit-btn {
          background: linear-gradient(135deg, #014c75 0%, #013a5c 100%);
          border: none;
          color: white;
          box-shadow: 0 4px 16px rgba(1, 76, 117, 0.3);
          min-width: 180px;

          &:hover {
            transform: translateY(-1px);
            box-shadow: 0 6px 20px rgba(1, 76, 117, 0.4);
          }
        }
      }
    }
  }
`;

export const ProjectDetailsWrapper = styled.div`
  padding: 24px;

  .header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 24px;

    .header-left {
      display: flex;
      align-items: center;
      gap: 16px;

      h2 {
        margin: 0;
        font-size: 24px;
        color: #014c75;
      }
    }

    .header-actions {
      display: flex;
      gap: 12px;
    }
  }

  .project-id-badge {
    font-size: 12px;
    color: #8c8c8c;
    margin-bottom: 8px;
  }

  .engagement-link-banner {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 16px;
    background: #f0f7ff;
    border: 1px solid #d6e4ff;
    border-radius: 8px;
    margin-bottom: 24px;
    cursor: pointer;

    &:hover {
      background: #e6f0ff;
    }

    .engagement-info {
      flex: 1;

      .label {
        font-size: 12px;
        color: #8c8c8c;
      }

      .title {
        font-size: 14px;
        font-weight: 500;
        color: #014c75;
      }
    }
  }

  .status-cards {
    margin-bottom: 24px;

    .status-card {
      border-radius: 12px;
      text-align: center;
      padding: 16px;

      .status-label {
        font-size: 12px;
        color: #8c8c8c;
        margin-bottom: 4px;
      }

      .status-value {
        font-size: 20px;
        font-weight: 600;

        &.good {
          color: #52c41a;
        }

        &.warning {
          color: #faad14;
        }

        &.critical {
          color: #ff4d4f;
        }
      }
    }
  }

  .details-section {
    margin-bottom: 24px;

    .section-title {
      font-size: 16px;
      font-weight: 600;
      color: #014c75;
      margin-bottom: 16px;
      padding-bottom: 8px;
      border-bottom: 1px solid #f0f0f0;
    }

    .info-grid {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
      gap: 16px;

      .info-item {
        .label {
          font-size: 12px;
          color: #8c8c8c;
          margin-bottom: 4px;
        }

        .value {
          font-size: 14px;
          color: #262626;
          font-weight: 500;
        }
      }
    }
  }
`;
